@let nav = item();
<li (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    @if (nav.external) {
        <a [href]="nav.path" target="blank" class="nav-link">
            @if (nav?.icon?.length) {
                <div class="icon">
                    <i [ngClass]="nav.icon"></i>
                </div>
            }
            <span class="label">
                {{ nav.title | translate }}
            </span>
        </a>
    } @else {
        <a [routerLink]="nav.path" routerLinkActive="active" class="nav-link">
            @if (nav?.icon?.length) {
                <div class="icon">
                    <i [ngClass]="nav.icon"></i>
                </div>
            }
            <span class="label">
                {{ nav.title | translate }}
            </span>
        </a>
    }
</li>

@if (!scrolling() && nav.children && nav.children.length > 0 && hover$ | async) {
    <app-subitem-nav [children]="nav.children" [top]="top" [left]="left" />
}
